<template>
  <div>
    <ul class="info_sel">
      <li
        v-for="(item, index) in list"
        :key="index"
        :class="{ active: item.active, disabled: item.disabled }"
        @click="$emit('changeBtn', item)"
      >{{ item.name }}</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'info-btn',
  props: {
    list: Array
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/base.scss";

.info_sel {
  display: flex;
  justify-content: space-between;
  height: 7.125vh;

  li {
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 165px;
    height: 100%;
    background: #fff;
    font-size: 30px; // IE11 fallback
    font-size: unquote("min(2.34375vw, 30px)");
    color: rgba(48, 48, 48, 0.5);
    border-radius: 0.375vh;
    &.active {
      background: $select;
      color: $white;
    }
    &:nth-last-child(2),
    &:nth-last-child(2) ~ li {
      width: 19.6875vw;
    }
    &:nth-last-child(3),
    &:nth-last-child(3) ~ li {
      width: 12.890625vw;
    }
    &:nth-last-child(4),
    &:nth-last-child(4) ~ li {
      width: 9.375vw;
    }
  }
}
</style>
